// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"43":"37bd2860976c657c","373":"b40e4a32b5d4d74a","627":"6397a910b0fedda4"}[chunkId] + ".js";
};